module.exports = __webpack_public_path__ + "img/AnwarAbbasDPS.7e86c2e3.jpg";